import { Observable, take } from "rxjs";

export function deviceIdFilter<T extends { deviceId: string }>(deviceId: string, obj: T | null): T | null {
    if (obj?.deviceId === deviceId) {
        return obj;
    }
    return null;
}

export function getCurrentValue<T>(observable: Observable<T>): T {
    let result: T;
    observable.pipe(take(1)).subscribe(v => result = v);
    return result;
}